/* MYOP sticky add-to-cart bar.
   Shows when the real Add-to-cart button leaves the viewport; mirrors the
   live price; proxies clicks to the real product form so Dawn's cart /
   variant logic stays authoritative. */
(function () {
  var bar = document.getElementById('MyopStickyAtc');
  if (!bar) return;

  var realBtn = document.querySelector('.product-form__submit');
  var priceSource = document.querySelector('[id^="price-"]');
  var barPrice = bar.querySelector('[data-satc-price]');
  var barBtn = bar.querySelector('[data-satc-add]');

  // Proxy click → real add-to-cart button
  if (barBtn && realBtn) {
    barBtn.addEventListener('click', function () { realBtn.click(); });
  }

  // Mirror the live price (updates on variant change via Dawn's DOM update)
  function readPrice() {
    if (!priceSource) return '';
    var sale = priceSource.querySelector('.price-item--sale:not(.hidden)');
    var reg = priceSource.querySelector('.price-item--regular');
    var node = sale || reg;
    return node ? node.textContent.trim() : priceSource.textContent.trim();
  }
  function syncPrice() {
    if (barPrice) {
      var p = readPrice();
      if (p) barPrice.textContent = p;
    }
  }
  syncPrice();
  if (priceSource && 'MutationObserver' in window) {
    new MutationObserver(syncPrice).observe(priceSource, {
      subtree: true, childList: true, characterData: true
    });
  }

  // Reflect sold-out / unavailable state
  function syncState() {
    if (realBtn && barBtn) {
      barBtn.disabled = realBtn.disabled;
      var real = realBtn.querySelector('span');
      var mine = barBtn;
      if (realBtn.disabled && real) mine.textContent = real.textContent.trim();
    }
  }

  // Show bar once the real button is scrolled out of view
  if ('IntersectionObserver' in window && realBtn) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        syncState();
      });
    }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
    io.observe(realBtn);
  }
})();
